import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import css from './error-boundary.scss';
import { BtnText } from '../../../components/buttons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className={css['error-boundary']}>
          <div className={css['error-content']}>
            <h2 className={css['error-title']}>
              <Trans>Something went wrong</Trans>
            </h2>
            <p className={css['error-message']}>
              <Trans>Data not found</Trans>
            </p>
            <BtnText callBack={() => window.history.back()}>
              <Trans>Back to Student Centre</Trans>
            </BtnText>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary;
